export const NAV = typeof window !== 'undefined' ? window.navigator : null;

export const UA = NAV ? NAV.userAgent.toLowerCase() : null;

export function isVideo(element) {
    return element.tagName.toLowerCase() === 'video';
}

export function isAudio(element) {
    return element.tagName.toLowerCase() === 'audio';
}

export const IS_SAFARI = UA ? /safari/i.test(UA) && !IS_CHROME : false;

export const IS_CHROME = UA ? /chrome/i.test(UA) : false;
/**
 * Check if current browser supports MediaSource API.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaSource
 * @type boolean
 * @default
 */
export const HAS_MSE = typeof window !== 'undefined' ? ('MediaSource' in window) : false;

/**
 * Check if current browser supports HLS streaming.
 *
 * @see https://github.com/video-dev/hls.js/blob/master/src/is-supported.js
 * @type boolean
 * @default
 */
export const SUPPORTS_HLS = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const mediaSource = window.MediaSource || window.WebKitMediaSource;
    const sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    const isTypeSupported = mediaSource &&
        typeof mediaSource.isTypeSupported === 'function' &&
        mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');

    const sourceBufferValidAPI = !sourceBuffer ||
        (sourceBuffer.prototype &&
        typeof sourceBuffer.prototype.appendBuffer === 'function' &&
        typeof sourceBuffer.prototype.remove === 'function');

    // Safari is still an exception since it has built-in HLS support; currently HLS.js
    // is still in beta to support Safari
    return !!isTypeSupported && !!sourceBufferValidAPI;
};

export function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => {
            removeElement(script);
            resolve();
        };
        script.onerror = () => {
            removeElement(script);
            reject();
        };
        document.head.appendChild(script);
    });
}

/**
 * Remove a node using removeChild as a way to support IE11
 *
 * @export
 * @param {Node} node
 * @returns {void}
 */
export function removeElement(node) {
    if (node) {
        const parentNode = node.parentNode;
        if (parentNode) {
            parentNode.removeChild(node);
        }
    }
}